import React from 'react';
import PageHeader from '../components/PageHeader';

const CONTACTS = [
  {
    label: 'Email',
    value: 'massimoterzi@hotmail.it',
    href: 'mailto:massimoterzi@hotmail.it',
    icon: '✉',
  },
  {
    label: 'LinkedIn',
    value: '/in/massimo-terzi-2b26b01a3',
    href: 'https://www.linkedin.com/in/massimo-terzi-2b26b01a3/',
    icon: 'in',
  },
  {
    label: 'GitHub',
    value: 'github.com/Ilvecho',
    href: 'https://github.com/Ilvecho',
    icon: '</>',
  },
  {
    label: 'Instagram',
    value: '@il_vecho',
    href: 'https://www.instagram.com/il_vecho?igsh=MWVla3A3NWM1N3J1bA%3D%3D&utm_source=qr',
    icon: '◎',
  },
];

const KNOWN_ISSUES = [
  "The travel page contains only the list of countries — I want to add more details about my experience in each country",
  "The Friends page is completely empty, but I promise I am working on it",
  "My career is on the making, give me the time to gather enough content for the page",
  "The blog, well, not even sure I will keep it — not even Silvi wants to hear what I have to say, and she loves me! (allegedly)",
  "The page about myself will be my biggest challenge — and I am paying a guy 50 euro an hour to help me, and the road is still very long",
  "Many of the images in the project page (you'll know which ones) are generated by ChatGPT, I claim 0 responsibility.",
  "If there are typos, then it's your fault — I asked you to find them!",
];

export default function Connect() {
  return (
    <div style={{ padding: '48px', maxWidth: '900px' }}>
      <PageHeader
        eyebrow="07 — Connect"
        title="Connect"
        subtitle="All the ways you can tell me I have a typo on my website."
      />

      <p style={{
        fontFamily: '"Cormorant Garamond", Georgia, serif',
        fontStyle: 'italic',
        fontSize: '1.15rem',
        color: 'var(--text-2)',
        marginBottom: '40px',
        marginTop: 0,
      }}>
        Or, you know, just say hi, or ask me about my projects, or whatever...
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '32px', flexWrap: 'wrap' }}>

        {/* Left: contact links */}
        <div>
          <div className="eyebrow" style={{ marginBottom: '20px' }}>Get in touch</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
            {CONTACTS.map((c) => (
              <a
                key={c.label}
                href={c.href}
                target={c.href.startsWith('mailto') ? '_self' : '_blank'}
                rel="noopener noreferrer"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '16px',
                  padding: '16px',
                  background: 'var(--surface)',
                  border: '1px solid var(--border)',
                  borderRadius: '8px',
                  textDecoration: 'none',
                  transition: 'border-color 0.15s ease, background 0.15s ease',
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.borderColor = 'var(--gold)';
                  e.currentTarget.style.background = 'var(--surface-2)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.borderColor = 'var(--border)';
                  e.currentTarget.style.background = 'var(--surface)';
                }}
              >
                <div style={{
                  width: '36px',
                  height: '36px',
                  borderRadius: '4px',
                  background: 'var(--surface-2)',
                  border: '1px solid var(--border)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontFamily: '"JetBrains Mono", monospace',
                  fontSize: '0.7rem',
                  color: 'var(--gold)',
                  flexShrink: 0,
                }}>
                  {c.icon}
                </div>
                <div>
                  <div style={{
                    fontFamily: '"JetBrains Mono", monospace',
                    fontSize: '0.6rem',
                    color: 'var(--text-3)',
                    letterSpacing: '0.08em',
                    marginBottom: '2px',
                  }}>
                    {c.label}
                  </div>
                  <div style={{
                    fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
                    fontSize: '0.82rem',
                    color: 'var(--text)',
                  }}>
                    {c.value}
                  </div>
                </div>
              </a>
            ))}
          </div>
        </div>

        {/* Right: availability + known issues */}
        <div>
          {/* Availability card */}
          <div className="eyebrow" style={{ marginBottom: '20px' }}>Status</div>
          <div style={{
            padding: '20px',
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: '8px',
            marginBottom: '28px',
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
              <div style={{
                width: '8px',
                height: '8px',
                borderRadius: '50%',
                background: '#4ade80',
                boxShadow: '0 0 0 3px rgba(74,222,128,0.2)',
                flexShrink: 0,
              }} />
              <span style={{
                fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
                fontSize: '0.85rem',
                fontWeight: 500,
                color: 'var(--text)',
              }}>
                Open to interesting conversations
              </span>
            </div>
            <p style={{
              fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
              fontSize: '0.78rem',
              color: 'var(--text-3)',
              margin: 0,
              lineHeight: 1.5,
            }}>
              Currently focused on Enterprise AI at Swift. Not looking for new roles,
              but always happy to talk about AI, automation, travel, or life in general.
            </p>
          </div>

          {/* Known issues */}
          <div className="eyebrow" style={{ marginBottom: '12px' }}>Known issues</div>
          <div style={{
            padding: '16px 20px',
            background: 'var(--surface)',
            border: '1px solid var(--border)',
            borderRadius: '8px',
          }}>
            <ul style={{ margin: 0, padding: 0, listStyle: 'none' }}>
              {KNOWN_ISSUES.map((issue, i) => (
                <li
                  key={i}
                  style={{
                    fontFamily: '"Plus Jakarta Sans", system-ui, sans-serif',
                    fontSize: '0.75rem',
                    color: 'var(--text-3)',
                    lineHeight: 1.55,
                    paddingBottom: i < KNOWN_ISSUES.length - 1 ? '8px' : 0,
                    marginBottom: i < KNOWN_ISSUES.length - 1 ? '8px' : 0,
                    borderBottom: i < KNOWN_ISSUES.length - 1 ? '1px solid var(--border)' : 'none',
                  }}
                >
                  {issue}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
}
